<script>
export default {
    name: "CsvImport",
    props: {
        columns: {
            type: Array,
            required: true
        },
        buttonText: {
            type: String,
            default: "Import"
        },
        exampleUrl: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
        };
    },
    methods: {
        doImport() {
            const input = this.$refs.fileInput;
            if (input.files.length === 0) {
                alert("Please select a file to import.");
                return;
            }
            this.loading = true;
            const file = input.files[0];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("columns", JSON.stringify(this.columns));

            window.axios.post("/api/import/csv", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(response => {
                this.$emit("imported", response.data.data);
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                alert("Error importing file: " + error.response.data.message);
            });
        }
    },
}
</script>

<template>
    <div class="csv-import csv-import-container">
        <div class="csv-import-input-wrapper">
            <input
                type="file"
                accept=".csv"
                ref="fileInput"
            >
            <p class="csv-import-help">
                .csv files accepted and should include a header row
            </p>
            <p v-if="exampleUrl">
                <a
                    :href="exampleUrl"
                    target="_blank"
                    download
                >Download Example</a>
            </p>
        </div>
        <button
            class="btn btn-outline-info"
            type="button"
            :disabled="loading"
            @click.prevent="doImport()"
        >
            <span v-if="!loading"><i class="fa fa-file-upload" /> {{ buttonText }}</span>
            <span v-else><i class="fa fa-spinner fa-spin" /> Uploading...</span>
        </button>
    </div>
</template>

<style lang="scss">
.csv-import {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background-color: #fdf6e0;
    border: 1px solid #ffecbf;
    border-radius: 2px;

    &-input-wrapper {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: .5rem;
        flex: 1;
    }

    &-help {
        margin: 0;
        font-size: 0.875rem;
        color: #2f2b20;
    }

    input[type="file"] {
        flex: 1;
        font-weight: bold;
    }

    .btn {
        background-color: #d3b865;
        border: 1px solid #af984d;
        color: #2f2b20;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/CsvImport.vue